const LoginButton = () => {
  const { brokerConfigs, applicationDomain } = window;
  const selectedBroker = applicationDomain.config.brokers[0];

  const href = brokerConfigs[selectedBroker].href;

  const loginRedirection = () => {
    window.location.href = href;
  };

  return (
    <div className="stockwiz-landing__container__login-btn flex-md-row">
      <button className="btn register" onClick={() => loginRedirection()}>
        <img src="/b2b/stockwiz/svg/xicon.svg" className="mx-2" alt="xicon" />
        New User Login
      </button>
      <button className="btn login" onClick={() => loginRedirection()}>
        <img src="/b2b/stockwiz/svg/dhanicon.svg" className="mx-2" alt="dhanicon" />
        Existing User Login
      </button>
    </div>
  );
};

export default LoginButton;
